import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-inventory",
  "use": "icon-inventory-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-inventory\"><path d=\"M853.333333 597.333333h-85.333333v-51.2l-256-256-256 256V768h256v85.333333H170.666667v-298.666666H128l384-384 384 384h-42.666667v42.666666z m-298.666666 42.666667h85.333333v85.333333h-85.333333v-85.333333z m0 128h85.333333v85.333333h-85.333333v-85.333333z m128-128h213.333333v85.333333h-213.333333v-85.333333z m0 128h213.333333v85.333333h-213.333333v-85.333333z\" p-id=\"8259\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol